// components/features/shops/ShopsList.tsx
import { Shop } from "@cabukaka/types";
import TableList, { SelectAction } from "../../ui/TableList";
import ShopRow from "./ShopRow";

interface ShopsListProps {
  shops: Shop[];
  onAction: (shop: Shop) => void;
  onSelectShops?: (selectedShops: Shop[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function ShopsList({
  shops,
  onAction,
  onSelectShops,
  selectable = false,
  selectActions
}: ShopsListProps) {
  const columns = [
    { header: "Boutique", className: "w-2/5" },
    { header: "Ville", className: "hidden sm:table-cell w-1/6" },
    { header: "Téléphone", className: "hidden sm:table-cell w-1/6" },
    { header: "Note", className: "hidden md:table-cell w-1/6" },
    { header: "Délai", className: "hidden lg:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={shops}
      columns={columns}
      getId={(shop) => shop.id}
      onAction={onAction}
      onSelectItems={onSelectShops}
      selectable={selectable}
      emptyMessage="Aucune boutique trouvée"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(shop, isSelected, onSelect) => (
        <ShopRow
          key={shop.id}
          shop={shop}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}